import { Component, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, HostListener, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from 'src/@core/services/notification.service';
import { ProgressBarService } from 'src/@core/services/progress-bar.service';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
  MatPaginator,
  MatSort,
  MatTableDataSource,
  PageEvent,
} from '@angular/material';
import { BehaviorSubject, Subscription, merge, of as observableOf } from 'rxjs';
import { fadeInUp400ms } from 'src/@core/animations/fade-in-up.animation';
import { stagger40ms } from 'src/@core/animations/stagger.animation';
import { Search } from 'src/@core/interfaces/search';
import { fadeInRight400ms } from 'src/@core/animations/fade-in-right.animation';
import { JobService } from 'src/@core/services/job/job.service';
import { AppService, CURRENT_USER } from 'src/@core/services/app.service';
import { entityTypes, permissions, roles } from 'src/app/shared/helpers/roles-permissions'
import { JobTypeService } from 'src/@core/services/job/job-type.service';
import { NavigationExtras, Router } from '@angular/router';
import { LocalStorageService } from 'src/@core/services/local-storage.service';
import { STATUS } from 'src/app/shared/helpers/status';
import { SelectionModel } from '@angular/cdk/collections';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { API_GET_SUMMARY, API_WORK_ORDER_EXPORT, GET_PO, GET_QUOTATION } from 'src/@core/services/util/api.endpoints';
import moment from 'moment';
import { EditViewBillDetailsComponent } from '../bills/edit-view-bill-details/edit-view-bill-details.component';
import { AddActivationImageComponent } from 'src/app/modules/dashboard/add-activation-image/add-activation-image.component';
import { ViewActivationImageComponent } from 'src/app/modules/dashboard/view-activation-image/view-activation-image.component';
import { environment } from 'src/environments/environment';
import { MapViewWithProjectComponent } from '../map-view-with-project/map-view-with-project.component';
import { UploadBulkWorkordersComponent } from './upload-bulk-workorders/upload-bulk-workorders.component';

@Component({
  selector: 'hour4u-admin-workorders',
  templateUrl: './workorders.component.html',
  styleUrls: ['./workorders.component.scss'],
  animations: [
    fadeInUp400ms,
    stagger40ms,
    fadeInRight400ms
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'standard'
      } as MatFormFieldDefaultOptions
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkordersComponent implements OnInit {
  dataChange: BehaviorSubject<any>;
  @Input() data?: any;
  roles = roles;
  permissions = permissions;
  entityTypes = entityTypes;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  title = 'Job';
  columns = [
    { columnDef: 'checkbox', visible: true, label: 'Checkbox' },
    { columnDef: 'name', visible: true, label: 'Name' },
    { columnDef: 'status', visible: true, label: 'Status' },
    { columnDef: 'city', visible: true, label: 'City' },
    { columnDef: 'agency', visible: true, label: 'Agency' },
    { columnDef: 'client', visible: true, label: 'Client' },
    { columnDef: 'fulfilment', visible: true, label: 'Fulfilment' },
    { columnDef: 'totalTasks', visible: true, label: 'Total Tasks' },
    { columnDef: 'approved', visible: true, label: 'Approved' },
    { columnDef: 'activationImage', visible: true, label: 'Activation Image' },
    { columnDef: 'activationApproval', visible: true, label: 'Activation Approval' },
    { columnDef: 'actions', visible: true, label: '' },
  ];
  displayedColumns = [...this.columns.map(x => x.columnDef)];

  profile = this.appService.getCurrentAccount();
  resultsLength: number = 0;
  pageIndex: number = 0;
  pageSize: number = 20;
  pageSizeOptions: number[] = [10, 20, 50, 100, 500];
  prevUrl: String;
  searchParams: Array<Search> = [];
  loginUserDetails: any = null;
  row: any;
  sort_field: string = '';
  diameter = 40;
  color: string;
  mode = 'indeterminate';
  status = STATUS;
  selectedAgency: any = null;
  selectedCreatedOn: any = null;
  selectedCreatedBy: any = null;
  selectedExpiredBy: any = null;
  agenciesList: any[] = [];
  createdByList: any[] = [];
  selection = new SelectionModel<any>(true, []);
  allRowsSelected: boolean = false;
  isLoading: boolean = false;
  workorderList: any[] = [];
  screenWidth = window.innerWidth;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenWidth = event.target.innerWidth;
  }
  arrayPOs: any[] = [];
  subscrier: Subscription;
  selectedOptions: any = [];
  selectedCityOptions: any = [];
  selectedAgencyOptions: any = [];
  selected: any = "";
  workOrderSummary: any;

  multiselectOptions = [
    // { value: 'Approved', label: 'Approved' },
    { value: 'Pending', label: 'Pending' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Active', label: 'Active' },
    { value: 'Rejected', label: 'Rejected' }
  ];

  cityMultiselectOptions = [
    { value: 'Delhi', label: 'Delhi' },
    { value: 'Gurugram', label: 'Gurugram' },
    { value: 'Mumbai', label: 'Mumbai' },
    { value: 'Bangalore', label: 'Bangalore' },
    { value: 'Hyderabad', label: 'Hyderabad' },
    { value: 'Chennai', label: 'Chennai' },
    { value: 'Kolkata', label: 'Kolkata' },
    { value: 'Pune', label: 'Pune' },
    { value: 'Dehradun', label: 'Dehradun' },
  ];
  s3Url = environment.image_url;
  agencyMultiselectOptions = [];
  filteredAgencyOptions: any[] = [];
  ranges: any = {
    'Today': [moment()],
    'Yesterday': [moment().subtract(1, "days")],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
  }
  selectedStatus: any = [];
  selectedCity: any = [];
  assignedEntities: any[] = [];
  isExporting: boolean = false;
  @Output() filterChange = new EventEmitter();

  constructor(private dialog: MatDialog,
    private service: JobService,
    private jobTypeService: JobTypeService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private notify: NotificationService,
    private progress: ProgressBarService,
    private appService: AppService,
    private _localStorageService: LocalStorageService,
    private http: HttpClient) {

    this.subscrier = this.service.getRefreshWorkorderPage().subscribe(res => {
      this.fetchWorkOrdersData();
      this.getWorkOrderSummary();
    });
  }

  ngOnInit() {
    this.dataChange = new BehaviorSubject(0);
    this.fetchWorkOrdersData();
    this.getWorkOrderSummary();
    this.getAllAgencies();
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  onFilterChange(): void {
    this.getWorkOrderSummary();
    this.fetchWorkOrdersData();
    this.emitFilterData();
  }

  emitFilterData() {
    let params = new HttpParams();

    // Add selected filters to params
    if (this.selectedCityOptions) {
      if (Array.isArray(this.selectedCityOptions)) {
        this.selectedCityOptions.forEach(city => {
          params = params.append('city', city);
        });
      } else {
        params = params.set('city', this.selectedCityOptions);
      }
    }
    if (this.selectedOptions) {
      if (Array.isArray(this.selectedOptions)) {
        this.selectedOptions.forEach(status => {
          params = params.append('status', status);
        });
      } else {
        params = params.set('status', this.selectedOptions);
      }
    }
    if (this.selectedAgencyOptions) {
      if (Array.isArray(this.selectedAgencyOptions)) {
        this.selectedAgencyOptions.forEach(agency => {
          params = params.append('agencyId', agency);
        });
      } else {
        params = params.set('agencyId', this.selectedAgencyOptions);
      }
    }

    // Add startDate and endDate if available
    if (this.selected && this.selected.startDate && this.selected.endDate) {
      params = params.set('startDate', this.selected.startDate.format('YYYY-MM-DD'));
      params = params.set('endDate', this.selected.endDate.format('YYYY-MM-DD'));
    }
    this.filterChange.emit(params);
  }

  fetchWorkOrdersData(page: number = this.pageIndex, pageSize: number = this.pageSize) {
    this.isLoading = true;
    let startDate = "";
    let endDate = "";

    if (this.selected && this.selected.startDate && this.selected.endDate) {
      startDate = moment(this.selected.startDate).format("YYYY-MM-DD");
      endDate = this.selected.endDate.toISOString().split("T")[0];
    }

    if (this.profile.entity.entityType == "AGENCY") {
      this.selectedAgency = [];
      this.selectedAgency.push(this.profile.entity.id);
    }

    let obj = {
      "jobId": this.data.id,
      "status": this.selectedOptions,
      "city": this.selectedCityOptions,
      "agency": this.selectedAgency,
      "startDate": startDate,
      "endDate": endDate,
    };

    // Construct HttpParams
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', pageSize.toString())
      .set('sort', 'createdOn,desc');

    Object.keys(obj).forEach(key => {
      if (obj[key] && obj[key].length) {
        params = params.append(key, obj[key]);
      }
    });

    // Fetch paginated data
    this.service.searchAndSortDashboardData(params)
      .subscribe(
        (response) => {
          this.workorderList = response.content || [];
          this.workorderList.forEach((workOrder) => {
            if (workOrder.activationProof === null) {
              workOrder.activationProof = { status: 'PENDING' };
            }
          });
          this.resultsLength = response.totalElements || this.workorderList.length;
          this.isLoading = false;
          this.cdRef.detectChanges();
        },
        (error) => {
          this.isLoading = false;
          console.error('Failed to fetch dashboard data:', error);
        }
      );
  }
  onPageChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.fetchWorkOrdersData(this.pageIndex, this.pageSize);
  }


  columnHideBasedOnLoggedInUser() {
    if (this.profile.entity.entityType == "ENTERPRISE") {
      this.columns = this.columns.map(x => {
        x.visible = true;
        if (x.columnDef === 'checkbox' || x.columnDef == 'client')
          x.visible = false;
        return x;
      });
      this.displayedColumns = this.columns.filter(x => x.visible).map(x => x.columnDef);
    }

    if (this.profile.entity.entityType == "AGENCY") {
      this.columns = this.columns.map(x => {
        x.visible = true;
        if (x.columnDef === 'agency')
          x.visible = false;
        return x;
      });
      this.displayedColumns = this.columns.filter(x => x.visible).map(x => x.columnDef);
    }

    if (this.data && this.data.billingType && this.data.billingType === 'NONE' || this.data.billingType.includes('FIXED') || this.data.billingType.includes('VARIABLE')) {
      this.columns = this.columns.map(x => {
        x.visible = true;
        if (x.columnDef === 'checkbox')
          x.visible = false;
        return x;
      });
      this.displayedColumns = this.columns.filter(x => x.visible).map(x => x.columnDef);
    }
  }

  onDateRangeChanged(event: any) {
    // console.log("Callllllllllllllllllllllll", event)
    if (event && event.startDate && event.endDate) {
      this.selected = event;
      this.fetchWorkOrdersData();
      this.getWorkOrderSummary();
    }
  }

  getEachFulfilment(element: any, billingItems: any[]): number {
    if (element.numberOfVariableFulfilment) {
      return element.numberOfVariableFulfilment;
    } else {
      if (billingItems && billingItems.length > 0) {
        // Only calculate the quantity of the item at index 0 i.e selected JobType
        return billingItems[0].quantity || 0;
      }
    }
    return 0;
  }

  reloadTable() {
    // this.dataChange.next(1);
  }

  // sortData(direction) {
  //   this.sort.active = 'createdOn';
  //   this.sort.direction = direction.value;
  //   this.sort.sortChange.next();
  // }

  dataRefresh() {
    this.fetchWorkOrdersData();
    this.getWorkOrderSummary();
    this.getAllAgencies();
  }

  // create PO
  // createPO() {
  //   console.log("##############", this.data)
  //   this.router.navigateByUrl("/job/create-bill/" + this.data.id);
  // }

  // edit Field
  editPO(row) {
    let data = Object.assign({}, this.data);
    data.poDetails = row;
    data.action = "Edit";

    // const dialogRef = this.dialog.open(CreateBillComponent, {
    //   width: '900px',
    //   panelClass: 'add-edit-staff-dialog',
    //   disableClose: true,
    //   data: data,
    //   autoFocus: true
    // });
    // dialogRef.afterClosed().subscribe(result => {
    //   if (result) {
    //     this.getPOData();
    //   }
    // });
  }

  getAllAgencies() {
    const searchParams = [];
    const entityId = this.profile.entity.id;
    if (entityId) {
      searchParams.push(new Search('entityType', 'AGENCY'));
      this.service.searchAndSortAgencies(entityId, this.pageIndex, 1000, 'createdOn', null, searchParams)
        .subscribe(data => {
          this.agencyMultiselectOptions = data.content.map(agency => ({
            value: agency.id,
            label: agency.entityMeta.name
          }));
          this.filteredAgencyOptions = this.agencyMultiselectOptions;
        }, error => {
        });
    } else {
      console.warn('Entity ID is not available. Unable to fetch agencies.');
    }
  }

  searchAgencyByInput(event) {
    console.log(this.agencyMultiselectOptions)
    const searchText = event.target.value.toLowerCase();
    this.filteredAgencyOptions = this.agencyMultiselectOptions.filter(data => {
      // Check if data.label is not null and is a string
      if (data.label && typeof data.label === 'string') {
        return data.label.toLowerCase().indexOf(searchText) !== -1;
      }
      return false; // Exclude items with null label or non-string label
    });
  }

  clearCitySelection(eventData: Event): void {
    this.selectedCityOptions = [];
    this.getWorkOrderSummary();
    this.fetchWorkOrdersData();
    eventData.stopPropagation();
  }

  clearAgencySelection(eventData: Event): void {
    this.selectedAgencyOptions = [];
    this.getWorkOrderSummary();
    this.fetchWorkOrdersData();
    eventData.stopPropagation();
  }

  clearStatusSelection(eventData: Event) {
    this.selectedOptions = [];
    this.getWorkOrderSummary();
    this.fetchWorkOrdersData();
    eventData.stopPropagation();
  }

  // refresh individual row
  dataRefreshIndividualRow(res) {
    this.workorderList.forEach((ele: any, index) => {
      if (ele.id == res.id) {
        ele.totalCost = 0;
        if (ele.jobRateCards && ele.jobRateCards.length) {
          ele.jobRateCards.forEach(ele1 => {
            ele.totalCost = ele.totalCost + ele1.totalAmount;
          });
          ele.totalCost = ele.totalCost * 1.18;
        }
        res.totalCost = ele.totalCost;
        this.workorderList[index] = res;
        this.workorderList = [...this.workorderList];
        // if (this.isAllSelected()) {
        this.selection.clear();
        this.workorderList.forEach(row => this.selection.select(row));
        // }
        console.log(this.workorderList)
        this.cdRef.detectChanges();
      }
    })
  }

  // Select all rows 
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.workorderList.length;
    // this.arrayPOs = [];
    // let data: any = Object.assign({}, this.selection);
    // if (data._selected && data._selected.length) {
    //   data._selected.forEach(element => {
    //     this.workorderList.forEach(el => {
    //       if (element.id == el.id) {
    //         this.arrayPOs.push(el)
    //       }
    //     })
    //   });
    // }
    return numSelected === numRows;
  }

  masterToggle(event: any) {
    console.log(event, this.workorderList, this.isAllSelected(), this.allRowsSelected)
    if (event.checked) {
      this.isAllSelected() ?
        this.selection.clear() :
        this.workorderList.forEach(row => { if (row.status == "Completed" && !row.billingCreated) this.selection.select(row) });
      this.isAllSelected() ? this.allRowsSelected = true : this.allRowsSelected = false;
    } else {
      this.selection.clear();
    }
  }

  // Pay Bill
  payBill(row: any) {
    console.log(row)
  }


  getWorkOrderSummary(): void {
    let params = new HttpParams();

    // Add selected filters to params
    if (this.selectedCityOptions) {
      if (Array.isArray(this.selectedCityOptions)) {
        this.selectedCityOptions.forEach(city => {
          params = params.append('city', city);
        });
      } else {
        params = params.set('city', this.selectedCityOptions);
      }
    }
    if (this.selectedOptions) {
      if (Array.isArray(this.selectedOptions)) {
        this.selectedOptions.forEach(status => {
          params = params.append('status', status);
        });
      } else {
        params = params.set('status', this.selectedOptions);
      }
    }
    if (this.selectedAgencyOptions) {
      if (Array.isArray(this.selectedAgencyOptions)) {
        this.selectedAgencyOptions.forEach(agency => {
          params = params.append('agencyId', agency);
        });
      } else {
        params = params.set('agencyId', this.selectedAgencyOptions);
      }
    }

    // Add startDate and endDate if available
    if (this.selected && this.selected.startDate && this.selected.endDate) {
      params = params.set('startDate', this.selected.startDate.format('YYYY-MM-DD'));
      params = params.set('endDate', this.selected.endDate.format('YYYY-MM-DD'));
    }
    params = params.set("jobId", this.data.id);
    // Make the HTTP request with the filtered params
    this.http.get(API_GET_SUMMARY, { params }).subscribe(
      result => {
        // console.log('Work Order Summary:', result);
        this.workOrderSummary = result;
      },
      error => console.error('Error fetching work order summary:', error)
    );
  }


  ngOnDestroy() {
    this.subscrier.unsubscribe();
  }

  cancelSelection() {
    this.selection.clear();
  }

  createBill() {
    let obj = Object.assign({}, this.data);
    obj.viewSeletedWorkOrdersOnly = true;
    obj.updateTitleOnly = false;
    obj.creteBilling = true;
    obj.actionTitle = "Name this bill";
    obj.selectedWorkOrders = this.selection.selected;
    // obj.title = "";
    if (obj.selectedWorkOrders && obj.selectedWorkOrders.length) {
      obj.selectedWorkOrders.forEach((order, index) => {
        if (index == 0) {
          obj.billingTitle = order.workOrderTitle ? order.workOrderTitle : order.venue.name;
        }
      })
    }
    const dialogRef = this.dialog.open(EditViewBillDetailsComponent, {
      width: '500px',
      panelClass: 'add-edit-staff-dialog',
      disableClose: true,
      data: obj,
      autoFocus: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // this.loadData();
        // this.refreshParent.emit();
      }
    });
  }

  handleUploadClick(event: Event, element: any) {
    event.stopPropagation();
    // Open the AddActivationImageComponent in a dialog
    const dialogRef = this.dialog.open(AddActivationImageComponent, {
      width: '500px',
      data: {
        workOrder: element,
        dashboardComponent: this
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Dialog closed with result:', result);
      if (result) {
        this.fetchWorkOrdersData();
        this.getWorkOrderSummary();
      }
    });
  }

  viewActivationImage(event: Event, element: any) {
    event.stopPropagation();

    // Check if imageUrl is available
    if (element.activationProof && element.activationProof.imageUrl) {
      const imageUrl = this.s3Url + element.activationProof.imageUrl;

      // Open the image in a modal dialog
      const dialogRef = this.dialog.open(ViewActivationImageComponent, {
        panelClass: 'add-edit-user-dialog',
        data: {
          imageUrl: imageUrl,
          workOrder: element,
          dashboardComponent: this
        },
      });

      // Prevent the default action (download) of the original click event
      event.preventDefault();
    } else {
      console.error('Image URL not available.');
    }
  }

  openMapView() {
    console.log("################", this.workorderList)
    let workorderList = [];
    workorderList = this.workorderList.filter(x => x.status == "Active");
    let obj = {
      workorders: workorderList,
      selectedProject: this.data
    }
    const dialogRef = this.dialog.open(MapViewWithProjectComponent, {
      width: '100%',
      height: '100%',
      maxWidth: '100%',
      data: obj,
      disableClose: true,
      panelClass: 'map-view'
    });
    dialogRef.afterClosed().subscribe(
      result => {
        console.log(result)
      }
    );
  }

  onWorkOrderClick(element: any): void {
    const workOrderId = element.id;
    if (element.status == 'Pending') {
      this.router.navigateByUrl('/enterprise-admin/view-work-order/' + workOrderId);
    } else {
      this.router.navigateByUrl('/employment/job-applications/all/' + workOrderId);
    }
  }

  viewTasks(event: Event, job) {
    event.stopPropagation();

    const url = this.router.serializeUrl(this.router.createUrlTree(['/employment/active/workproof/', job.id, {
      date: job.dates[0].date,
      for: 'all',
      view: 'table'
    }]));

    window.open(url, '_blank');
  }
  stopPropagation(event: Event) {
    event.stopPropagation();
  }

  // // Change application status
  // changeApplicationStatus(status, job) {
  //   let obj = {
  //     "updatedStatus": status,
  //     "assignerId": job.id,
  //     "fulfillerType": this.currentUserRole
  //   }
  //   if (status == 'ACCEPTED') {

  //     this.approveWorkOrder(job);
  //   } else if (status = 'AGENCY_APPROVED') {
  //     this.approveWorkOrderByAgency(job)
  //   } else if (status = 'AGECNY_REJECTED') {
  //     this.rejectWorkOrderByAgency(job);
  //   }
  //   else {
  //     this.rejectWorkOrder(job);
  //   }
  // }

  exportData(selectedCity: string, selectedStatus: string, selectedAgency: string) {
    this.isExporting = true;
    let params = new HttpParams();

    // Add selected filters to params
    if (selectedCity) {
      if (Array.isArray(selectedCity)) {
        selectedCity.forEach(city => {
          params = params.append('city', city);
        });
      } else {
        params = params.set('city', selectedCity);
      }
    }
    if (selectedStatus) {
      if (Array.isArray(selectedStatus)) {
        selectedStatus.forEach(status => {
          params = params.append('status', status);
        });
      } else {
        params = params.set('status', selectedStatus);
      }
    }
    if (selectedAgency) {
      if (Array.isArray(selectedAgency)) {
        selectedAgency.forEach(agency => {
          params = params.append('agencyId', agency);
        });
      } else {
        params = params.set('agencyId', selectedAgency);
      }
    }

    // Add startDate and endDate if available
    if (this.selected && this.selected.startDate && this.selected.endDate) {
      params = params.set('startDate', this.selected.startDate.format('YYYY-MM-DD'));
      params = params.set('endDate', this.selected.endDate.format('YYYY-MM-DD'));
    }

    params = params.set('jobId', this.data.id);

    this.http.get(API_WORK_ORDER_EXPORT, { params, responseType: 'blob', observe: 'response' })
      .subscribe((response: HttpResponse<Blob>) => {
        this.isLoading = false;
        this.isExporting = false;
        // Handle the API response, which is a file to download
        const blob = new Blob([response.body!], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);

        // Create a link element and trigger the download
        const a = document.createElement('a');
        a.href = url;
        a.download = 'workorder-data.xlsx'; // specify the desired filename here
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }, (err => {
        this.isLoading = false;
        this.isExporting = false;
      }));
  }

  uploadFile() {
    const dialogRef = this.dialog.open(UploadBulkWorkordersComponent, {
      width: '900px',
      panelClass: 'add-edit-staff-dialog',
      disableClose: true,
      data: this.data,
      autoFocus: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.fetchWorkOrdersData();
        this.getWorkOrderSummary();
      }
    });
  }
  clearDateRange(event) {
    event.stopPropagation();
    this.selected = null;
    this.fetchWorkOrdersData();
  }
}